import { createActions } from 'redux-actions';
import accedoOneApi from '#/services/accedoOne/api';
import {
  getFAQService,
  getPrivacyPolicyService,
  getHelpService,
  getTextContent,
} from '#/services/settings/settings';

import { containersAgeGroup, initialVideoContainers } from '#/config/constants';

import { loadContainers } from '../brightcove/actions';
import {
  getTermsOfServiceUrl,
  getChildrenPrivacyPolicyUrl,
  menuEntry,
} from './selectors';
import { getClientServices } from '#/services';

const SET_CLIENT = 'SET_CLIENT';
const SAVE_ALL_ASSETS = 'SAVE_ALL_ASSETS';
const SAVE_ALL_ENTRIES = 'SAVE_ALL_ENTRIES';
const SAVE_ALL_METADATA = 'SAVE_ALL_METADATA';
const SAVE_SENSICAL_BENEFITS = 'SAVE_SENSICAL_BENEFITS';
const LOAD_SENSICAL_FAQ = 'LOAD_SENSICAL_FAQ';
const LOAD_SENSICAL_HELP = 'LOAD_SENSICAL_HELP';
const LOAD_SENSICAL_PRIVACY_POLICY = 'LOAD_SENSICAL_PRIVACY_POLICY';
const SAVE_TERMS_OF_SERVICE = 'SAVE_TERMS_OF_SERVICE';
const SAVE_CHILDREN_PRIVACY_POLICY = 'SAVE_CHILDREN_PRIVACY_POLICY';
const SAVE_ALL_GUEST_METADATA = 'SAVE_ALL_GUEST_METADATA';

const actionOptions = {
  prefix: 'sensical/accedoOne',
};

export const actions = createActions(
  {},
  SET_CLIENT,
  SAVE_ALL_ENTRIES,
  SAVE_ALL_ASSETS,
  SAVE_ALL_METADATA,
  SAVE_ALL_GUEST_METADATA,
  SAVE_SENSICAL_BENEFITS,
  LOAD_SENSICAL_FAQ,
  LOAD_SENSICAL_HELP,
  LOAD_SENSICAL_PRIVACY_POLICY,
  SAVE_TERMS_OF_SERVICE,
  SAVE_CHILDREN_PRIVACY_POLICY,
  actionOptions,
);

export const saveAllAssets = payload => {
  return {
    type: `${actionOptions.prefix}/${SAVE_ALL_ASSETS}`,
    payload,
  };
};

export const saveAllEntries = payload => {
  return {
    type: `${actionOptions.prefix}/${SAVE_ALL_ENTRIES}`,
    payload,
  };
};

export const saveAllMetadata = payload => {
  return {
    type: `${actionOptions.prefix}/${SAVE_ALL_METADATA}`,
    payload,
  };
};

export const saveAllGuestMetadata = payload => {
  return {
    type: `${actionOptions.prefix}/${SAVE_ALL_GUEST_METADATA}`,
    payload,
  };
};

export const saveSensicalBenefits = payload => {
  return {
    type: `${actionOptions.prefix}/${SAVE_SENSICAL_BENEFITS}`,
    payload,
  };
};

export const loadSensicalFaq = payload => {
  return {
    type: `${actionOptions.prefix}/${LOAD_SENSICAL_FAQ}`,
    payload,
  };
};

export const loadSensicalHelp = payload => {
  return {
    type: `${actionOptions.prefix}/${LOAD_SENSICAL_HELP}`,
    payload,
  };
};

export const loadSensicalPrivacyPolicy = payload => {
  return {
    type: `${actionOptions.prefix}/${LOAD_SENSICAL_PRIVACY_POLICY}`,
    payload,
  };
};

export const loadAllAssets = async (dispatch, getState) => {
  try {
    const res = await accedoOneApi.getAllAssets(
      getState().modules.accedoOne.sessionKey,
    );
    dispatch(saveAllAssets(res));
  } catch (error) {
    // TODO: do logic to a possible redispatch
  }
};

export const loadAllEntries = async (dispatch, getState) => {
  try {
    const entries = await accedoOneApi.getAllEntries(
      getState().modules.accedoOne.sessionKey,
    );
    const stateObject = {};
    entries.forEach(item => {
      stateObject[item._meta.id] = item;
    });
    dispatch(saveAllEntries(stateObject));

    const onboardingEntryId = getState().modules?.accedoOne?.metadata
      ?.onboardingEntryId;
    const onboardingEntry = onboardingEntryId
      ? stateObject[onboardingEntryId]
      : null;

    console.info('[AccedoRuntime] entries loaded', {
      entriesCount: entries.length,
      onboardingEntryId,
      onboardingEntryType: onboardingEntry?.type,
      onboardingItemsCount: onboardingEntry?.items?.length || 0,
      onboardingItems: onboardingEntry?.items || [],
    });
  } catch (error) {
    console.error(error);
  }
};

export const loadInitialSwimlanes = async (dispatch, getState) => {
  const getContent = () => {
    const menu = menuEntry(getState());
    const entries = getState().modules.accedoOne?.entries;

    const content = {};
    menu?.menuItems?.forEach(item => {
      const menuItem = entries?.[item];
      const page = entries?.[menuItem.page];
      if (page) {
        content[page.template] = page;
      }
    });
    return content;
  };

  const content = getContent();
  const numSwimlanes = 5;

  let swimlaneIds = [];
  swimlaneIds = swimlaneIds.concat(
    content?.home[containersAgeGroup.CONTAINER_2Up]?.slice(0, numSwimlanes),
  );
  swimlaneIds = swimlaneIds.concat(
    content?.home[containersAgeGroup.CONTAINER_5Up]?.slice(0, numSwimlanes),
  );
  swimlaneIds = swimlaneIds.concat(
    content?.home[containersAgeGroup.CONTAINER_8Up]?.slice(0, numSwimlanes),
  );

  const swimlaneEntries = await getClientServices()?.service.getEntries({
    id: swimlaneIds,
  });

  const findBrightcoveId = swimlanes => {
    return swimlanes.filter(s => s.disableInTv === false && s.playlistId)?.[0];
  };

  const bcIds = [];
  bcIds.push(
    findBrightcoveId(swimlaneEntries?.entries?.slice(0, numSwimlanes))
      ?.playlistId,
  );
  bcIds.push(
    findBrightcoveId(
      swimlaneEntries?.entries?.slice(numSwimlanes, numSwimlanes * 2),
    )?.playlistId,
  );
  bcIds.push(
    findBrightcoveId(
      swimlaneEntries?.entries?.slice(numSwimlanes * 2, numSwimlanes * 3),
    )?.playlistId,
  );

  const initialVideoContainerIds = [
    initialVideoContainers.CONTAINER_2Up,
    initialVideoContainers.CONTAINER_5Up,
    initialVideoContainers.CONTAINER_8Up,
  ];

  dispatch(
    loadContainers({
      queries: bcIds.map((id, i) => ({
        playlistId: id,
        containerId: initialVideoContainerIds[i],
        limit: 1,
      })),
    }),
  );
};

export const loadAllMetadata = async (dispatch, getState) => {
  try {
    const metadata = await accedoOneApi.getAllMetadata(
      getState().modules.accedoOne.sessionKey,
    );
    dispatch(saveAllMetadata(metadata));

    console.info('[AccedoRuntime] metadata loaded', {
      appKey: getState().modules?.accedoOne?.appKey,
      onboardingEntryId: metadata?.onboardingEntryId,
      welcomeAgeSelector: metadata?.featureSpecificConfigs?.welcomeAgeSelector,
      sensicalTvConfig: metadata?.sensicalTvConfig,
    });
  } catch (error) {
    console.error(error);
  }
};

export const loadGuestData = async (dispatch, getState) => {
  try {
    const unauthenticatedWelcomeAgeContainer = getState().modules?.accedoOne
      ?.metadata?.featureSpecificConfigs?.welcomeAgeSelector;
    const getUnauthenticatedWelcomeAgeContainer = getState().modules?.accedoOne
      ?.entries?.[unauthenticatedWelcomeAgeContainer];
    if (!getUnauthenticatedWelcomeAgeContainer) {
      return {
        setAllEntriesByContent: {},
        totalCount: 0,
        parentSignInButtonText: '',
        signUpButtonText: '',
      };
    }
    const setAllEntriesByContent = {};
    const {
      tiles,
      parentSignInButtonText,
      signUpButtonText,
    } = getUnauthenticatedWelcomeAgeContainer;
    const getAllEntries = tiles
      .map(entryId => {
        const entry = getState().modules?.accedoOne?.entries?.[entryId];
        if (entry) {
          setAllEntriesByContent[entry.typeOfContent] =
            setAllEntriesByContent[entry.typeOfContent] || [];
          setAllEntriesByContent[entry.typeOfContent].push(entry);
          return entry;
        }
        return null;
      })
      .filter(x => x);
    dispatch(
      saveAllGuestMetadata({
        setAllEntriesByContent,
        totalCount: getAllEntries.length,
        parentSignInButtonText,
        signUpButtonText,
      }),
    );

    console.info('[AccedoRuntime] guest welcome data loaded', {
      welcomeAgeSelector: unauthenticatedWelcomeAgeContainer,
      tileIds: tiles || [],
      tileCount: getAllEntries.length,
      contentTypes: Object.keys(setAllEntriesByContent),
    });
  } catch (error) {
    console.error(error);
  }
};

export const loadSensicalBenefits = url => async dispatch => {
  try {
    const benefits = await accedoOneApi.getSensicalBenefits(url);
    dispatch(saveSensicalBenefits(benefits));
  } catch (error) {
    console.error(error);
  }
};

export const requestFAQ = async (dispatch, getState) => {
  try {
    const faqUrl = getState().modules?.accedoOne?.metadata?.faqUrl;
    const faq = await getFAQService(faqUrl);
    dispatch(loadSensicalFaq(faq));
  } catch (error) {
    console.error(error);
  }
};

export const requestHelp = async (dispatch, getState) => {
  try {
    const helpUrl = getState().modules?.accedoOne?.metadata?.helpUrl;
    const help = await getHelpService(helpUrl);
    dispatch(loadSensicalHelp(help));
  } catch (error) {
    console.error(error);
  }
};

export const requestPrivacyPolicy = async (dispatch, getState) => {
  try {
    const privacyPolicyUrl = getState().modules?.accedoOne?.metadata
      ?.privacyPolicyUrl;
    const privacyPolicy = await getPrivacyPolicyService(privacyPolicyUrl);
    dispatch(loadSensicalPrivacyPolicy(privacyPolicy));
  } catch (error) {
    console.error(error);
  }
};

export const loadTermsOfService = async (dispatch, getState) => {
  const termsOfServiceUrl = getTermsOfServiceUrl(getState());
  const tosText = await getTextContent(termsOfServiceUrl);
  dispatch(actions.saveTermsOfService(tosText));
};

export const loadChildrenPrivacyPolicy = async (dispatch, getState) => {
  const childrenPrivacyPolicyUrl = getChildrenPrivacyPolicyUrl(getState());
  const text = await getTextContent(childrenPrivacyPolicyUrl);
  dispatch(actions.saveChildrenPrivacyPolicy(text));
};

export const { setClient } = actions;
